import { useEffect } from 'react';

/**
 * Capture mouse clicks outside target ref element
 *
 *
 * https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
 *
 * @param {*} ref
 * @param {*} callback
 */
export default function useClickedOutside(ref, callback = null) {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            if (typeof callback === 'function') {
                callback(event);
            }
        }
    }

    useEffect(() => {
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });
}
